export default "__VITE_ASSET__KDcsuUKd__"